module.exports = __webpack_public_path__ + "static/media/vinos_blancos.0f795bec.jpg";